<!--充值管理-->
<template>
  <div class="fundaccount">
    <el-form :model="listQuery" ref="listQuery" label-width="auto" style="text-align: left" :rules="rules">
      <el-form-item :label="$t('wallet.russia')">
        {{ listQuery.B$ }} {{ this.wallet }}
      </el-form-item>
      <!--     金额 -->
      <el-form-item :label="$t('Account.money') + (':')" prop="money">
        <el-input style="width: 50%" v-model="listQuery.money" @blur="numberToCurrencyNo" type="number" clearable
          :placeholder="$t('login.pass.amount')" />
        <span> {{ this.symbol }}</span>
        <span style="color: green;margin-left: 50px;font-size:18px">{{ this.moneyNum }} {{ $symbol() }}</span>
        <!-- <p v-if="companyCode === 'COL'" style="color: #999;margin: 0;">{{ $t('Please_Enter_A_Multiple_Of_1000') }}</p> -->
      </el-form-item>
      <!--      公司名称-->
      <el-form-item v-if="this.listQuery.tranType === '0'" :label="$t('corporate.name') + (':')">
        {{ this.listQuery.companyName }}
      </el-form-item>
      <!--      银行账户-->
      <el-form-item v-if="this.listQuery.tranType === '0'" :label="$t('Bank.account') + (':')">
        {{ this.listQuery.bankKey }}
      </el-form-item>
      <!--      开户银行-->
      <el-form-item v-if="this.listQuery.tranType === '0'" :label="$t('bank.of.deposit') + (':')">
        {{ this.listQuery.bankValue }}
      </el-form-item>
      <!--      银行代码-->
      <el-form-item v-if="this.listQuery.tranType === '0'" :label="$t('Bank.code') + (':')">
        {{ this.listQuery.bankCode }}
      </el-form-item>
      <!--      汇款人-->
      <el-form-item v-if="showPayer()" :label="$t('remitter') + (':')" required>
        <el-input v-model="listQuery.payer" />
      </el-form-item>
      <!--      备注-->
      <el-form-item :label="$t('pmProductSppm.remark') + (':')">
        <el-input v-model="listQuery.memo" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" clearable
          :placeholder="$t('')" />
      </el-form-item>
      <!--      交易密码-->
      <el-form-item :label="$t('transaction.password') + (':')" prop="payPassword">
        <el-input :placeholder="$t('login.pass.input')" v-model="listQuery.payPassword" show-password></el-input>
      </el-form-item>
      <!--      付款方式-->
      <el-form-item :label="$t('fiPayAdvice.dealType') + (':')" prop="tranType">
        <el-radio-group v-model="listQuery.tranType" @change="tranTypeChange">
          <el-radio v-for="role in transTypeList" :key="role.code" :label="role.code" border
            style="display: block;margin-left: 0;margin-top: 10px">
            <template>
              {{ $t(role.title) }}
            </template>
          </el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <!-- <span style="float: right">
      <el-button size="mini" :loading="btnloading" type="warning" @click="confirmBtn('listQuery')" plain>{{
        $t('btn.implement') }}</el-button>
    </span> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getPersonalData2, saveOrUpdateFiAcInput, sysBanklist } from "@/api/rus/api";

export default {
  name: "FundAccount",
  data() {
    const validateMoney = (rule, value, callback) => {
      if (value <= 0) {
        return callback(new Error(this.$t('po.setInfo')))
      } else {
        callback()
      }
    }
    return {
      symbol: null,
      wallet: null,
      electronics: null,
      listQuery: {
        cardType: '10',
        isSave: null,
        creditCard: null,
        validityYear: null,
        validityMonth: null,
        F$: 0,
        B$: 0,
        money: 0,
        payPassword: '',
        tranType: '',
        nameOnCard: '',
        cardAsn: '',
        cardExpireMonth: '',
        cardExpireYear: '',
        cardCvc: '',
        surname: '',
        email: '',
        cvv: '',
        payer: '',
        mobile: '',
        bankKey: ''
      },
      moneyNum: 0,
      btnloading: false,
      rules: {
        money: [
          { required: true, validator: validateMoney, trigger: ['change', 'blur'] }
        ],
        payPassword: [
          { required: true, message: this.$t('login.pass.input'), trigger: ['change', 'blur'] }
        ],
        tranType: [
          { required: true, message: this.$t('login.pass.payment.method'), trigger: ['change', 'blur'] }
        ],
        acType: [
          { required: true, message: this.$t('login.pass.payment.method'), trigger: ['change', 'blur'] }
        ],
      },
      initDict: {
        yesNo: 'yesno',
        fiPayAdvicedealType: 'trans_type_cn',
        credit_card_type: 'credit_card_type'
      },
    }
  },
  computed: {
    ...mapGetters([
      'language',
      'userCode',
      'username',
      'companyCode',
    ]),
    transTypeList() {
      if (this.companyCode === 'MEX') {
        return this.$ll(this.initDict.fiPayAdvicedealType).filter(ele => ele.code === '0' || ele.code === '1' || ele.code === '2')
      }
      return this.$ll(this.initDict.fiPayAdvicedealType).filter(ele => ele.code === '0' || ele.code === '2')
    },
    creditCardTypeList() {
      return this.$ll(this.initDict.credit_card_type)
    },
    yesNoList() {
      return this.$ll(this.initDict.yesNo)
    }
  },
  created() {
    this.getCreditCardShowI()
    this.getBalance()
    this.getSymbol()
  },
  methods: {
    showPayer() {
      if (this.listQuery.tranType === '0') {
        return true
      }
      if (this.listQuery.tranType === '2') {
        if (this.companyCode === 'MEX') {
          return false
        }
        if (this.companyCode === 'COL') {
          return true
        }
        return false
      }
      return false
    },
    tranTypeChange() {
      this.listQuery.nameOnCard = ''
      this.listQuery.cardAsn = ''
      this.listQuery.cardExpireMonth = ''
      this.listQuery.cardExpireYear = ''
      this.listQuery.cardCvc = ''
      this.listQuery.surname = ''
      this.listQuery.email = ''
      this.listQuery.creditCard = ''
      this.listQuery.cardType = ''
      this.listQuery.isSave = ''
      this.listQuery.cvv = ''
      this.listQuery.validityMonth = ''
      this.listQuery.validityYear = ''
      this.listQuery.mobile = ''
      this.listQuery.payer = ''
    },
    getCreditCardShowI() {
      sysBanklist().then(res => {
        if (!res.data) {
          return
        }
        if (res.data.length === 0) {
          return
        }
        this.listQuery.bankKey = res.data[0].bankKey
        this.listQuery.bankValue = res.data[0].bankValue
        this.listQuery.bankCode = res.data[0].bankCode
        this.listQuery.companyName = res.data[0].companyName
      }).catch(err => {
        console.error(err)
      })
    },
    numberToCurrencyNo() {
      if (!this.listQuery.money) {
        this.moneyNum = 0
        return
      }
      if (isNaN(Number(this.listQuery.money))) {
        this.moneyNum = 0
        return
      }
      if (this.companyCode === 'MEX') {
        // 获取整数部分
        const intPart = Math.trunc(this.listQuery.money)
        // 整数部分处理，增加,
        const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        // 预定义小数部分
        let floatPart = ''
        // 将数值截取为小数部分和整数部分
        const valueArray = this.listQuery.money.toString().split('.')
        if (valueArray.length === 2) { // 有小数部分
          floatPart = valueArray[1].toString() // 取得小数部分
          return this.moneyNum = intPartFormat + '.' + floatPart
        }
        return this.moneyNum = intPartFormat + floatPart
      }
      if (this.companyCode === 'COL') {
        //如果this.listQuery.money 除以1000 有余数则返回报错
        // if (this.listQuery.money % 1000 !== 0) {
        //   // 请输入1000的倍数
        //   this.$message.error(this.$t('Please_Enter_A_Multiple_Of_1000'))
        //   this.listQuery.money = 0
        //   this.moneyNum = 0
        //   return
        // }
        this.moneyNum = Number(this.listQuery.money).toLocaleString()
      }
    },
    getSymbol() {
      this.electronics = '$'
      if (this.companyCode === 'RUS') {
        this.symbol = 'Руб' //单位(货币)
        this.wallet = '₽' //符号
      } else if (this.companyCode === 'MEX') {
        this.symbol = 'MXN'
        this.wallet = ''
      }
    },
    getBalance() {
      getPersonalData2({ 'userCode': this.userCode }).then(res => {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].acType === 'B$') {
            this.listQuery.B$ = res.data[i].validBalance
          }
          if (res.data[i].acType === 'F$') {
            this.listQuery.F$ = res.data[i].validBalance
          }
        }
      })
    },
    confirmBtn(listQuery) {
      this.listQuery.userCode = this.userCode
      this.listQuery.username = this.username
      this.listQuery.payNum = this.listQuery.bankKey
      this.listQuery.acType = 'B$'
      this.listQuery.rate = 1
      if (this.listQuery.tranType === '0') {
        if (this.listQuery.payer === '') {
          this.$message.info(this.$t('po.setInfo') + ' ' + this.$t('remitter'))
          this.btnloading = false
          return false;
        }
      }

      if (this.listQuery.tranType === '2' && this.companyCode === 'COL') {
        if (this.listQuery.payer === '') {
          this.$message.info(this.$t('po.setInfo') + ' ' + this.$t('remitter'))
          this.btnloading = false
          return false;
        }
      }
      this.$refs[listQuery].validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('fi.sure.handle'), this.$t('common.tips'), {
            confirmButtonText: this.$t('button.confirm'),
            cancelButtonText: this.$t('operation.button.cancel'),
            customClass: 'msgBox',
            type: 'warning'
          }).then(() => {
            this.btnloading = true
            saveOrUpdateFiAcInput({ ...this.listQuery }).then(res => {
              if (this.listQuery.tranType === '1') {
                window.location.replace(res.data.paymentRequestUrl)
              } else {
                this.$router.push({ name: 'AccountHistory' })
                this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
              }
            }).catch((e) => {
              console.log(e, 'error')
            }).finally(() => {
              this.btnloading = false
            })
          }).catch(() => {
            this.btnloading = false
            this.$message({
              type: 'info',
              message: this.$t('operation.button.cancel')
            })
          })
        } else {
          this.btnloading = false
        }
      })
    },
    resetForm(listQuery) {
      this.$refs[listQuery].resetFields()
    }
  }
}
</script>

<style scoped>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
  appearance: textfield !important;
  -moz-appearance: textfield !important;
}
</style>
